"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _Inline = _interopRequireDefault(require("./Components/Inline"));
var _Fixed = _interopRequireDefault(require("./Components/Fixed"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    gridItemRoot: function gridItemRoot(_ref) {
      var isFixedThinVariant = _ref.isFixedThinVariant;
      return {
        maxWidth: isFixedThinVariant ? '28px' : 'auto'
      };
    },
    gridRoot: {
      height: '100%'
    },
    root: function root(_ref2) {
      var noPadding = _ref2.noPadding;
      return {
        padding: noPadding ? 0 : theme.spacing(3)
      };
    },
    stepActionBar: function stepActionBar(props) {
      return {
        '& button:first-child': {
          marginRight: theme.spacing(1)
        },
        flex: 0,
        textAlign: props.alignment
      };
    },
    stepConnectorHoriz: {
      margin: '0 8px',
      maxWidth: theme.spacing(3)
    },
    stepConnectorVert: {
      paddingTop: theme.spacing(1)
    },
    stepContentBody: {
      flex: 1,
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(3)
    },
    stepContentRoot: function stepContentRoot(_ref3) {
      var isHorizontal = _ref3.isHorizontal,
        isInlineVariant = _ref3.isInlineVariant;
      var marginTop = 0;
      var paddingLeft = 0;
      if (isInlineVariant) {
        marginTop = theme.spacing(1);
        paddingLeft = theme.spacing(4) + 2;
      }
      if (!isInlineVariant && !isHorizontal) {
        paddingLeft = theme.spacing(3);
      }
      if (isHorizontal) {
        marginTop = theme.spacing(2);
      }
      return {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        marginTop: marginTop,
        paddingLeft: paddingLeft,
        paddingRight: 0
      };
    },
    stepContentTitle: {
      marginTop: theme.spacing(2)
    },
    stepIcon: {
      padding: 0
    },
    stepLabel: function stepLabel(_ref4) {
      var isInlineVariant = _ref4.isInlineVariant;
      return {
        '& span': _objectSpread({}, theme.typography.subtitle1),
        display: isInlineVariant ? 'block' : 'none',
        paddingLeft: theme.spacing(3)
      };
    },
    stepRoot: {
      justifyContent: 'center',
      padding: 0
    },
    stepThinRoot: {
      '& > div': {
        backgroundColor: theme.palette.grey[300],
        height: '2px',
        // Rotated so this is now Width
        width: '100%' // Rotated so this is now Height
      },

      left: '12px',
      minWidth: '150px',
      // Rotated so this is now Height
      padding: 0,
      position: 'relative',
      transform: 'rotate(90deg)',
      transformOrigin: 'left'
    },
    stepTransition: function stepTransition(_ref5) {
      var transitions = _ref5.transitions;
      return {
        transition: transitions ? 'height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' : 'none'
      };
    }
  };
});
var defaultProps = {
  activeStep: 0,
  alignment: 'left',
  className: '',
  dataMetrics: {
    root: 'fuse_stepper'
  },
  error: -1,
  noPadding: false,
  orientation: 'vertical',
  transitions: true,
  variant: 'inline'
};

/**
 * Steppers convey progress through numbered steps. It provides a wizard-like workflow.
 */
function Stepper(_ref6) {
  var activeStep = _ref6.activeStep,
    alignment = _ref6.alignment,
    className = _ref6.className,
    dataMetrics = _ref6.dataMetrics,
    error = _ref6.error,
    orientation = _ref6.orientation,
    noPadding = _ref6.noPadding,
    primaryButton = _ref6.primaryButton,
    secondaryButton = _ref6.secondaryButton,
    stepContent = _ref6.stepContent,
    transitions = _ref6.transitions,
    variant = _ref6.variant;
  var isInlineVariant = variant === 'inline';
  var isFixedThinVariant = variant === 'fixedThin';
  var isHorizontal = orientation === 'horizontal';
  var classes = useStyles({
    alignment: alignment,
    isFixedThinVariant: isFixedThinVariant,
    isHorizontal: isHorizontal,
    isInlineVariant: isInlineVariant,
    noPadding: noPadding,
    transitions: transitions
  });
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root,
    "data-metrics": mergedDataMetrics.root
  }, isInlineVariant ? /*#__PURE__*/_react["default"].createElement(_Inline["default"], {
    activeStep: activeStep,
    classes: classes,
    className: className,
    error: error,
    orientation: orientation,
    primaryButton: primaryButton,
    secondaryButton: secondaryButton,
    stepContent: stepContent
  }) : /*#__PURE__*/_react["default"].createElement(_Fixed["default"], {
    activeStep: activeStep,
    classes: classes,
    className: className,
    error: error,
    isFixedThin: isFixedThinVariant,
    orientation: orientation,
    primaryButton: primaryButton,
    secondaryButton: secondaryButton,
    stepContent: stepContent
  }));
}
Stepper.defaultProps = defaultProps;
Stepper.displayName = 'Stepper';
Stepper.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The index of the current step.
   */
  activeStep: _propTypes["default"].number,
  /**
   * The alignment of the action bar.
   */
  alignment: _propTypes["default"].oneOf(['left', 'center', 'right']),
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * The index of the step to mark as failed or invalid.
   */
  error: _propTypes["default"].number,
  /**
   * If `true`, removes outer padding from Stepper
   */
  noPadding: _propTypes["default"].bool,
  /**
   * The orientation of the stepper.
   */
  orientation: _propTypes["default"].oneOf(['horizontal', 'vertical']),
  /**
   * The primary action button.
   */
  primaryButton: _propTypes["default"].node,
  /**
   * The secondary action button.
   */
  secondaryButton: _propTypes["default"].node,
  /**
   * The title and content for each step:
   *
   * ```
   *   stepContent: [
   *     {
   *      stepTitle: "Step title",
   *      contentTitle: "Content title",
   *      contentBody: "Text, Element or Component"
   *     }
   *   ]
   * ```
   * > `contentBody`- **required** <br>
   * > `stepTitle`- **required**
   */
  stepContent: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    contentBody: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].element]).isRequired,
    contentTitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
    stepTitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired
  })).isRequired,
  /**
   * Whether transition animations are enabled.
   *
   * **NOTE:**
   * Affects inline variant only
   */
  transitions: _propTypes["default"].bool,
  /**
   * The variant to use.
   */
  variant: _propTypes["default"].oneOf(['inline', 'fixed', 'fixedThin'])
} : {};
var _default = Stepper;
exports["default"] = _default;